/**
 * MC4 S3 — E2E observability hook: mirrors a slice of `OverlayState` onto
 * `window.__edit_dwg_overlay` for headless scenarios. Read-only, no
 * production code depends on it — same pattern as `window.__cam`.
 *
 * Extracted from `Scene3DStage.tsx` (OTRACK-SUBSYSTEM — that file sits at
 * its 2000-line hard cap; this self-contained effect has zero coupling to
 * anything else in the component body) — pure code move, no behaviour
 * change.
 *
 * N6: `polarGuide` (WebGL canvas, no DOM selector) is included so a
 * scenario can observe the dashed line independent of `polarTip`'s DOM
 * presence (TRACKPATH suppresses only the line, not the tooltip).
 * OTRACK-SUBSYSTEM adds `otrackGuides`/`otrackMarkers`/`otrackTip` likewise.
 */

import { useEffect } from "react";

import type { OverlayState } from "../overlays";

type OverlayMirror = Pick<
  OverlayState,
  | "snapTarget"
  | "snapTip"
  | "polarGuide"
  | "polarTip"
  | "otrackGuides"
  | "otrackMarkers"
  | "otrackTip"
>;

export function useOverlayE2EMirror(overlayState: OverlayState): void {
  useEffect(() => {
    (window as unknown as { __edit_dwg_overlay?: OverlayMirror }).__edit_dwg_overlay = {
      snapTarget: overlayState.snapTarget ?? null,
      snapTip: overlayState.snapTip ?? null,
      polarGuide: overlayState.polarGuide ?? null,
      polarTip: overlayState.polarTip ?? null,
      otrackGuides: overlayState.otrackGuides ?? null,
      otrackMarkers: overlayState.otrackMarkers ?? null,
      otrackTip: overlayState.otrackTip ?? null,
    };
  }, [
    overlayState.snapTarget,
    overlayState.snapTip,
    overlayState.polarGuide,
    overlayState.polarTip,
    overlayState.otrackGuides,
    overlayState.otrackMarkers,
    overlayState.otrackTip,
  ]);
}
